import { render, staticRenderFns } from "./calligraphyPop.vue?vue&type=template&id=75b84a40&scoped=true&"
import script from "./calligraphyPop.vue?vue&type=script&lang=js&"
export * from "./calligraphyPop.vue?vue&type=script&lang=js&"
import style0 from "./calligraphyPop.vue?vue&type=style&index=0&id=75b84a40&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b84a40",
  null
  
)

export default component.exports